import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ConsultationInvestigations } from "./consultationInvestigations";
import { ConsultationDiagnostics } from "./consultationDiagnostics";
import { ConsultationFiles } from "./consultationFiles";
import { Input, TextArea  } from "@progress/kendo-react-inputs";
import { TimePicker, DatePicker } from "@progress/kendo-react-dateinputs";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DialogDoctor } from "./dialogDoctor";
import { CustomDropdown } from "../shared/customDropdown";
import { utils } from "../../services/helpers/utils";
import { alertService } from '../../services/helpers/alert.service';
import { consulationService } from '../../services/api/consultation.service';
import { partnerService } from '../../services/api/partner.service';
import { reportService } from '../../services/api/report.service';

export const Consultation = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigate = useNavigate();

    const partener = sessionStorage.getItem("idPartener");
    const user = sessionStorage.getItem("idUtilizator");

    const maxDateLimit = new Date();

    /*Parametrii consulatiei */
    const param = {
        pacient: searchParams.get("pacient"),
        contract: searchParams.get("contract"),
        consultatie: searchParams.get("consultatie"),
        titlu: searchParams.get("consultatie") ? "Consultatie" : "Adauga consultatie",
        speciala: searchParams.get("speciala") ? true : false,
    }

    const [IDConsultatie, setIDConsultatie] = useState(param.consultatie);
    const [isModified, setIsModified] = useState(false);

    // Folosita pentru a retrage recalcularea detailiilor de investigatii
    const [forceRecalcul, setForceRecalcul] = useState(false);

    /* Consultatia */
    const [consultatie, setConsultatie] = useState({});
    const [render, setRender] = useState(false);
    const [marjaProcentuala, setMarjaProcentuala] = useState( null );

    // Listele de investigatii, diagnostice si fisiere
    const [investigatii, setInvestigatii] = useState([]);
    const [diagnostice, setDiagnostice] = useState([]);
    const [fisiere, setFisiere] = useState([]);
    const [doRender, setDoRender] = useState(false);

    /* Dialog */
    const [visibleDialog, setVisibleDialog] = useState(false);

    const toggleDialog = () => {
        setVisibleDialog(!visibleDialog);
    };

    useEffect(() => {

        // Setam consulatia
        if (IDConsultatie) {
            consulationService.getConsultation({ consultation: IDConsultatie })
                .then(response => {
                    if (response) {

                        setConsultatie(response);
                        setDoRender(true);
                    }

                });
        }
        else if (param.pacient && param.contract) {
            consulationService.getConsultationHeader({
                pacient: param.pacient,
                subscription: param.contract,
                partener: partener
            })
                .then(response => {
                    if (response) {
                        setConsultatie(response);
                        setDoRender(true);
                    }

                });
        }

    }, []);

    useEffect(() => {
        if (marjaProcentuala == null && consultatie?.data != null) {
            partnerService.getIncreasePercentage({ partener: partener, data: consultatie.data })
                .then (response => {
                    if (response >= 0) {
                        setMarjaProcentuala(response);
                    }
                    
                });
        }
    }, [consultatie]);
    
    useEffect(() => {
        setIsModified(false);
    },[]);

    const handleChange = (event) => {
        const { name, value } = event.target;

        // Daca se trage handleChange dar inca nu avem consultatia setata
        if (!consultatie.hasOwnProperty(name)) {
            return
        }

        // Verificari speciale
        if (name === "laborator") {

            setConsultatie((prevParams) => ({
                ...prevParams,
                istoric: null,
                clinice: null,
                paraclinice: null,
                simptome: null
            }));

            if (investigatii.length > 0) {  
                if (event.setValue) {
                    event.setValue(consultatie.laborator == "Y" ? { id: "Y", text: "Laborator" } : { id: "N", text: "Clinica" })
                }             
                alertService.error("Nu puteti schimba tipul consultatiei daca aveti investigatii introduse!");
                return;
            }
        }
     

        // Cand se schimba ora am nevoie de procesarea valorii
        if (name === "ora") {
            let ora = utils.convertDateToTimeString(value);
            setConsultatie((prevParams) => ({ ...prevParams, [name]: ora }));
            return;
        }

        // daca value e obiect
        if (typeof value === "object") {
            // Daca are id e dropdown
            if (value && value.hasOwnProperty("id")) {
                if (consultatie[name] === value.id) {
                    return;
                }
                setConsultatie((prevParams) => ({ ...prevParams, [name]: value.id }));
            }
            // Daca nu are id e data sau null
            else {
                setConsultatie((prevParams) => ({ ...prevParams, [name]: value }));
            }
        }
        else {
            setConsultatie((prevParams) => ({ ...prevParams, [name]: value }));
        }
        setIsModified(true);
    }
       



    const verify = () => {

        if (!consultatie.idMedic) {
            alertService.error("Completati medicul intern!");
            return false;
        }

        if (!consultatie.idMedicTrimitator) {
            alertService.error("Completati medicul trimitator!");
            return false;
        }

        if (!diagnostice || diagnostice.length === 0) {
            alertService.error("Trebuie sa adaugati cel putin un diagnostic");
            return false;
        }

        if (!investigatii || investigatii.length === 0) {
            alertService.error("Trebuie sa adaugati cel putin o investigatie");
            return false;
        }

        if (diagnostice.length > 0) {
            for ( var i=0; i < diagnostice.length; i++) {
                if (!diagnostice[i].idDiagnostic) {
                    alertService.error("Completati diagnosticul de la randul " + ( i + 1) + "!");
                    return false;
                }
            };
        }

        if (investigatii.length > 0) {
            for( var i = 0; i < investigatii.length; i++) {
                if (!investigatii[i].idInvestigatie) {
                    alertService.error("Completati investigatia de la randul " + ( i + 1) + "!");
                    return false;
                }
            }
        }

        if (consultatie.nrReg) {
            const nrRegAsString = String(consultatie.nrReg).trim();
            if (isNaN(nrRegAsString) || nrRegAsString === '') {
                alertService.error("Numarul de inregistrare trebuie sa fie un numar!");
                return;
            }
        }

        return true;
    }

    /* Salvare */
    const handleSave = ( paramConsultatie ) => {

        const saveCons = paramConsultatie.hasOwnProperty("id") ? paramConsultatie : consultatie;

        if (!verify()) return;

        const isFinalizata = (saveCons.statusFinalizare == 1);

        // Păstrăm detaliuReducere pentru salvare (comentariu din API este mapat în detaliuReducere)
        let _investigatii = [...investigatii];
        for (var i = 0; i < _investigatii.length; i++) {
            // Asigurăm că detaliuReducere are valoarea corectă (comentariu sau detaliuReducere salvat)
            if (_investigatii[i].comentariu) {
                _investigatii[i].detaliuReducere = _investigatii[i].detaliuReducere || _investigatii[i].comentariu;
            }
            delete _investigatii[i].comentariu;
        }

        const formData = new FormData();
        convertObject(formData, saveCons, 'consultatie');
        convertArray(formData, _investigatii, 'investigatii');
        convertArray(formData, diagnostice, 'diagnostice');
        convertFiles(formData, fisiere, 'fisiere');


        consulationService.saveConsultation(formData).then(response => {
            if (response) {
                const message = (isFinalizata) ? "Consultatia a fost finalizata cu succes!" : "Consultatia a fost salvata cu succes!";
                alertService.success(message);
                setRender(!render);
                
                if (response.id && !IDConsultatie) {
                    setIDConsultatie(response.id);
                    setConsultatie((prevParams) => ({ ...prevParams, id: response.id }));
                    return true;
                }


                
            }
            else {
                return false;
            }
        });

    }

    /* Finalizare */
    const handleCompletion = () => {
        if (!verify()) return;

        // Daca consultatia este deja finalizata nu mai facem nimic
        if (consultatie.statusFinalizare == 1) {
            return
        }

        setForceRecalcul( true );

        
    }

    
    /* Metoda handleInvestigationDetailsCompleted se trage de pe componenta ConsultationInvestigations */

    const handleInvestigationDetailsCompleted = () => {
        // Continuați cu salvarea sau alte acțiuni necesare
        setForceRecalcul(false);
        const updatedConsultation = { ...consultatie, statusFinalizare: 1 };
        setConsultatie(updatedConsultation);
        
        handleSave(updatedConsultation);
        
    };


    const convertObject = (formData, item, path) => {
        Object.keys(item).forEach(key =>
            formData.append(`${path}.${key}`, item[key] ?? ''));
    }

    const convertArray = (formData, list, path) => {
        for (var i = 0; i < list.length; i++) {
            convertObject(formData, list[i], `${path}[${i}]`);
        }
    }

    const convertFiles = (formData, list, path) => {
        for (var i = 0; i < list.length; i++) {
            var file = {
                Id: list[i].id,
                IdConsultatie: list[i].idConsultatie,
                Description: list[i].descriere,
                File: list[i].fisier
            };
            convertObject(formData, file, `${path}[${i}]`);
        }
    }


    /* Inchide*/
    const handleCancel = () => {
        if (consultatie.statusFinalizare == 1) {
            navigate(-1);
            return;
        } 
        
        if (isModified) {
            alertService.confirm("Atentie", "Datele au fost modificate. Renuntati la modificari?",
                () => { navigate(-1); },
                () => { return });
        }
        else {
            navigate(-1);
        }
        return
    }

    /* Tiparire */
    const handlePrint = () => {
        if ( (consultatie.id ?? 0) == 0 ) {
            alertService.error("Salvati mai intai!");
            return;
        }

        reportService.RaportRaportMedical({ Consultatie: consultatie.id }).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/pdf");
            }
        });
      
    }

    return (
        <div className="add-consultation">
           

            <h2 className="pt20 pb10" name="titlu">{param.titlu}</h2>
            <p>Completati detaliile necesare pentru a modifica consulatia curenta. O consultatie trebuie sa includa cel putin un diagnostic si cel putin o investigatie. Daca apasati Inapoi veti reveni la pagina anterioara cu lista de abonamente ale pacientului</p>

            <div className="clearfix pt10 pb10">
                <div className="fl">
                    <h3 className="pb5" name="nume_pacient">{consultatie.numePacient} - {consultatie.codPacient }</h3>
                    <p>
                        Data si ora inregistrarii: <span name="datareg_date">{consultatie.dataOraInregistrare}</span>
                    </p>
                    <p>Status finalizare: <span name="status_finalizare"> {(consultatie.statusFinalizare ? "Finalizate" : "Nefinalizata")} </span></p>
                </div>
                <div className="fr text-right">
                    <label className="pb5 clearfix">Data ora consultatiei:</label>
                    <div className="clearfix float-right">
                        <DatePicker className="w120 fl"
                            name="data"
                            value={ new Date (consultatie.data) }
                            max={maxDateLimit}
                            disabled={consultatie.statusFinalizare == 1}
                            onChange={handleChange}
                        />
                        <TimePicker
                            className="ml20 w120 fl "
                            name="ora"
                            value={utils.convertHour(consultatie.ora)}
                            format="HH:mm:ss"
                            disabled={ true}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>

            <div className="formular">
                <fieldset>
                    <label className="pb5">Tip abonament:</label>
                    <Input className="w400 greybg" name="abonament" value={consultatie.abonament} readOnly />
                    <label className="pt10 pb5">Detalii abonament:</label>
                    <TextArea
                        name="note"
                        className="greybg notebox"
                        readOnly
                        value={"Nota pacient: " + (consultatie.notaInterna ? consultatie.notaInterna : "") + "\n" +
                            "Nota firma: " + (consultatie.notaFirma ? consultatie.notaFirma : "")} />
                </fieldset>

                <div className="pt10 pb15 clearfix">
                    <div className="fl">
                        <fieldset className="hidden-fildset">
                            <label className="pb5">Partener:</label>
                            <Input className=""
                                name="id_partener"
                                value={consultatie.numePartener}
                                readOnly />
                            <label className="pt10 pb5">Medic intern: <span className="red">*</span></label>
                            <div className="clearfix">
                                <CustomDropdown
                                    request={partnerService.getInternalDoctors}
                                    initialValue={consultatie.idMedic}
                                    requestParams={{ partener: (param.consultatie ? consultatie.idPartener : partener) }}
                                    name="idMedic"
                                    className="fl"
                                    onChangeEvent={handleChange}
                                    doRender={doRender}
                                    disabled={consultatie.statusFinalizare == 1}
                                    isSearcheable={true}
                                    filterable
                                />
                            </div>
                            <label className="pt10 pb5">Numar registru consultatie:</label>
                            <Input name="nrReg" className="" 
                                onChange={handleChange}
                                value={consultatie.nrReg ?? ""}
                                disabled={consultatie.statusFinalizare == 1}
                            />
                        </fieldset>
                    </div>
                    <div className="fr">
                        <fieldset className="hidden-fildset">
                            <label className="pb5">Locatie:</label>
                            <div className="clearfix">
                                <CustomDropdown
                                    request={param.speciala ? partnerService.getSpecialLocations : partnerService.getLocations }
                                    initialValue={consultatie.idLocatie ?? 0}
                                    requestParams={{ partener: (param.consultatie ? consultatie.idPartener : partener )}}
                                    name="idLocatie"
                                    className="text fl"
                                    onChangeEvent={handleChange}
                                    doRender={doRender}
                                    disabled={consultatie.statusFinalizare == 1 || investigatii.length > 0}
                                />
                            </div>
                            <div className="pt10 clearfix">
                                <label className="pb5">Medic trimitator: <span className="red">*</span></label>
                                <div className="d-flex">
                                    <CustomDropdown
                                        name="idMedicTrimitator"
                                        className="text fl w-80"
                                        request={partnerService.getExternalDoctors}
                                        requestParams={{ partener: (param.consultatie ? consultatie.idPartener : partener) }}
                                        initialValue={consultatie.idMedicTrimitator}
                                        onChangeEvent={handleChange}
                                        doRender={doRender}
                                        disabled={consultatie.statusFinalizare == 1 || investigatii.length > 0}
                                        isSearcheable={true}
                                        filterable
                                        
                                    />
                                    {consultatie.statusFinalizare != 1 &&
                                        <Button themeColor={"primary"}
                                            className="ml10"
                                            onClick={() => toggleDialog()} >Adaugă medic  </Button>
                                    }
                                </div>
                            </div>
                            <div className="pt5 clearfix">
                                <label className="pb5">Tip consultatie:</label>
                                <CustomDropdown
                                    name="laborator"
                                    className="text fl"
                                    data={[{ id: "N", text: "Clinica" }, { id: "Y", text: "Laborator" }]}
                                    value={consultatie.laborator == "Y" ? { id: "Y", text: "Laborator" } : { id: "N", text: "Clinica" }}
                                    initialValue={consultatie.laborator}
                                    onChangeEvent={handleChange}
                                    disabled={consultatie.statusFinalizare == 1}
                                />
                            </div>
                        </fieldset>
                    </div>
                </div>
                {(consultatie.laborator != 'Y') && 
                <div className="clearfix" name="numai_consultatii">
                    <div className="fl">
                        <fieldset className="hidden-fildset">
                            <label className="pb5">Simptome:</label>
                            <TextArea name="simptome" className=""
                                value={consultatie.simptome}
                                onChange={handleChange}
                                disabled={consultatie.statusFinalizare == 1}
                            />

                            <label className="pt10 pb5">Clinice:</label>
                            <TextArea name="clinice"
                                className=""
                                value={consultatie.clinice}
                                onChange={handleChange}
                                disabled={consultatie.statusFinalizare == 1}
                            />
                        </fieldset>
                    </div>
                    <div className="fr">
                        <fieldset className="hidden-fildset">
                            <label className="pb5">Istoric:</label>
                            <TextArea name="istoric"
                                className=""
                                value={consultatie.istoric}
                                onChange={handleChange}
                                disabled={consultatie.statusFinalizare == 1}
                            />

                            <label className="pt10 pb5">Paraclinice:</label>
                            <TextArea name="paraclinice"
                                className=""
                                value={consultatie.paraclinice}
                                onChange={handleChange}
                                disabled={consultatie.statusFinalizare == 1}
                            />
                        </fieldset>
                    </div>
                </div>
                }
                <div className="pt10 pb20" >
                    <fieldset className="hidden-fildset">
                        <label className="pb5">Recomandari: </label>
                        <TextArea name="recomandari" className=""
                            value={consultatie.recomandari}
                            onChange={handleChange}
                            disabled={consultatie.statusFinalizare == 1}
                        />
                    </fieldset>
                </div>

                <ConsultationDiagnostics
                    consultatie={IDConsultatie}
                    setDiagnostice={setDiagnostice}
                    statusFinalizare={consultatie.statusFinalizare}
                    setIsModified={setIsModified}
                    render={render}
                />

                <ConsultationInvestigations
                    consultatie={IDConsultatie}
                    data={consultatie?.dataOraInregistrare}
                    pacient={ (consultatie?.idPacient ?? param.pacient)}
                    locatie={consultatie?.idLocatie}
                    abonament={ (consultatie?.idAbonament ?? param.abonament)}
                    tip={ consultatie?.laborator ?? "N"}
                    idConsultatie = { consultatie.id }
                    idMedicTrimitator={consultatie.idMedicTrimitator}
                    partener={consultatie.id ? consultatie.idPartener : partener}
                    user={ consultatie.idUtilizatorAdd ?? user}
                    procentMajorare={marjaProcentuala}
                    param={
                        {
                            data: consultatie?.dataOraInregistrare,
                            pacient: consultatie?.idPacient ?? param.pacient,
                            locatie: consultatie?.idLocatie,
                            abonament: consultatie?.idAbonament ?? param.abonament,
                            tip: consultatie?.laborator,
                            partener : consultatie.id ? consultatie.idPartener : partener,
                        }
                    }
                    setInvestigatii={setInvestigatii}
                    statusFinalizare={consultatie.statusFinalizare}
                    setIsModified={setIsModified}
                    render={render}
                    forceRecalcul={forceRecalcul}
                    onDetailsCompleted={handleInvestigationDetailsCompleted} 
                />
                
                <ConsultationFiles
                    consultatie={IDConsultatie}
                    setFisiere={setFisiere}
                    statusFinalizare={consultatie.statusFinalizare}
                    setIsModified={setIsModified}
                    partener={consultatie.id ? consultatie.idPartener : partener}
                    render={render}
                />

                <div className="pt20 pb20 clearfix">
                    <p className="paragraf red mt15">Campurile marcate cu * sunt obligatorii.</p>
                    <div className="fl">
                        <button className="btn" name="back" onClick={handleCancel}>Inchide</button>
                    </div>
                    <div className="fr text-right">
                        {
                            consultatie.statusFinalizare !== 1 &&
                            <button className="btn" name="save" type="button" onClick={handleSave}>Salveaza</button>
                        }
                        <button className="btn" name="tipareste" onClick={handlePrint}>Tipareste raport medical</button>
                        {
                            consultatie.statusFinalizare !== 1  &&
                            <button className="btn" name="finalizeaza" onClick={handleCompletion}>Finalizeaza</button>
                        }
                    </div>
                </div>
            </div>

            {visibleDialog && (
                <Dialog title={"Adauga medic"} onClose={toggleDialog}>
                    <DialogDoctor toggleDialog={toggleDialog} />
                    <DialogActionsBar>
                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={toggleDialog}
                        >
                            Salveaza
                        </button>
                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={toggleDialog}
                        >
                            Inchide
                        </button>
                    </DialogActionsBar>
                </Dialog>
            )}                

        </div>);
}